export default "/images/76c18c7dea604e7624ea4a7ee0cc7b52.avif";